import { sl } from "../../../../date-fns/locale/sl.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    sl
  }
};